import "./App.css";
import { ThemeProvider } from "./providers/ThemeProvider";
import { lazy, Suspense } from "react";
import { useLocation } from "./lib/browserRouter";
import Checkout from "./pages/Checkout/Checkout";
import FunnelContinue from "./pages/FunnelContinue/FunnelContinue";
import ThankYou from "./pages/ThankYou/ThankYou";
import CommerceCheckout from "./pages/CommerceCheckout/CommerceCheckout";
import SalesPage from "./pages/SalesPage/SalesPage";

// Lazy load secondary route components
const PageNotFound = lazy(() => import("./pages/PageNotFound/PageNotFound"));

// Loading component
const Loading = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
  </div>
);

function AppRoutes() {
  const { pathname } = useLocation();
  let page;
  if (pathname === "/funnel-continue") {
    page = <FunnelContinue />;
  } else if (pathname === "/obrigado" || pathname === "/obrigado/") {
    page = <ThankYou />;
  } else if (/^\/commerce\/[^/]+\/?$/.test(pathname)) {
    page = <CommerceCheckout />;
  } else if (/^\/p\/[^/]+\/[^/]+\/?$/.test(pathname)) {
    page = <SalesPage />;
  } else if (/^\/p\/[^/]+\/?$/.test(pathname)) {
    page = <SalesPage />;
  } else if (/^\/[^/]+\/?$/.test(pathname)) {
    page = <Checkout />;
  } else {
    page = <PageNotFound />;
  }

  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <div className="App flex flex-col sm:flex-row">
        <Suspense fallback={<Loading />}>{page}</Suspense>
      </div>
    </ThemeProvider>
  );
}

export default AppRoutes;
